import type { FC, ReactNode } from 'react';
import { Helmet } from 'react-helmet';
import { useFormatMessage } from '@/hooks';

type IProps = {
  title?: string;
  description?: string;
  keywords?: string;
  children?: ReactNode;
};

const SEO: FC<IProps> = ({ title, description, keywords, children }) => {
  const { formatMessage } = useFormatMessage();

  return (
    <Helmet>
      <title>{title || formatMessage({ id: 'seo.common.title' })}</title>
      <meta
        name="description"
        content={description || formatMessage({ id: 'seo.common.description' })}
      />
      <meta
        name="keywords"
        content={keywords || formatMessage({ id: 'seo.common.keywords' })}
      />
      {children}
    </Helmet>
  );
};

export default SEO;
